// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__26XDO","topBottomGutter":"Layout_topBottomGutter__oFUbL"};